import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    epost: '',
    passord: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(formData.epost, formData.passord);

    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Takstmann System</h1>
        <h2>Logg inn</h2>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="epost">E-post</label>
            <input
              type="email"
              id="epost"
              name="epost"
              value={formData.epost}
              onChange={handleChange}
              required
              autoComplete="email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="passord">Passord</label>
            <input
              type="password"
              id="passord"
              name="passord"
              value={formData.passord}
              onChange={handleChange}
              required
              autoComplete="current-password"
            />
          </div>

          <button type="submit" disabled={loading} className="btn-primary">
            {loading ? 'Logger inn...' : 'Logg inn'}
          </button>
        </form>

        <p className="forgot-password-link">
          <Link to="/glemt-passord">Glemt passord?</Link>
        </p>

        <p className="register-link">
          Har du ikke konto? <Link to="/register">Registrer deg her</Link>
        </p>

        <div className="test-credentials">
          <p><strong>Test-bruker:</strong></p>
          <p>E-post: test@takstfabrikken.no</p>
          <p>Passord: test123</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
